module.exports = __webpack_public_path__ + "img/vehicle-violation.5fa2a759.svg";